module.exports = "<div class=\"cookies\" ng-if=\"$ctrl.showMessage\" ng-class=\"{geo: $ctrl.language === 'GE'}\">\n    <span>{{$ctrl.DESCRIPTIONS[0]}}\n        <a href=\"/privacy-policy#cookies\">{{$ctrl.DESCRIPTIONS[1]}}</a>\n    </span>\n    <button ng-click=\"$ctrl.gotIt()\">\n        <span>{{$ctrl.BUTTON}}</span>\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/cookies/cookies.html
// module id = 938
// module chunks = 0